import {useIntl} from 'react-intl'
import {useSelector} from 'react-redux'
import {StoreModel} from '../../../../app/redux/types'
import {HasPermission} from '../../../global/functions'
import {AsideMenuItem} from './AsideMenuItem'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'

export function AsideMenuMain() {
  const intl = useIntl()
  const {currentUser} = useSelector((state: StoreModel) => state.globalStates)

  return (
    <>
      <div className='menu-item'>
        <div className='menu-link'>
          <span className='menu-title' style={{fontSize: 9}}>
            YOU ARE LOGGED IN AS:<br></br>
            {currentUser?.current_business_name}
          </span>
          <p></p>
        </div>
      </div>

      <AsideMenuItem
        to={`${
          currentUser && currentUser?.business_list.length > 0 ? '/dashboard' : '/dashboard-new'
        }`}
        icon='/media/icons/duotune/layouts/lay001.svg'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Settings</span>
        </div>
      </div>

      <AsideMenuItemWithSub
        to='/business'
        title='Business Settings'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/ecommerce/ecm008.svg'
      >
        <AsideMenuItem to='/business/addbusiness' title='Add New Business' hasBullet={true} />
        <AsideMenuItem to='/business/mybusinesses' title='My Businesses' hasBullet={true} />
        <AsideMenuItem to='/business/allbusinesses' title='All Businesses' hasBullet={true} />
      </AsideMenuItemWithSub>

      {currentUser && currentUser?.business_list.length > 0 && (
        <AsideMenuItemWithSub
          to='/app'
          title='System Administration'
          icon='/media/icons/duotune/abstract/abs023.svg'
          fontIcon='bi-person'
        >
          {(HasPermission('department', 'create') ||
            HasPermission('department', 'read') ||
            HasPermission('department', 'update') ||
            HasPermission('department', 'delete')) && (
            <AsideMenuItem to='app/departments/all' title='Departments' hasBullet={true} />
          )}
          {/* Modules are shown always if user is part of any business */}
          <AsideMenuItem to='app/modules' title='Modules' hasBullet={true} />
          {(HasPermission('role', 'create') || HasPermission('role', 'read')) && (
            <AsideMenuItem to='app/roles/all' title='Roles' hasBullet={true} />
          )}
          {(HasPermission('invite_link', 'create') ||
            HasPermission('invite_link', 'read') ||
            HasPermission('invite_link', 'update') ||
            HasPermission('invite_link', 'delete')) && (
            <AsideMenuItem to='app/invitelinks/all' title='Invite Links' hasBullet={true} />
          )}
          {(HasPermission('profile', 'create') || HasPermission('profile', 'read')) && (
            <AsideMenuItem to='app/profiles/all' title='Profiles' hasBullet={true} />
          )}
          {(HasPermission('subscription', 'read') || currentUser?.is_pay_by_user) && (
            <AsideMenuItem to='app/subscriptions/all' title='Subscription' hasBullet={true} />
          )}
          {(HasPermission('user', 'create') ||
            HasPermission('user', 'read') ||
            HasPermission('user', 'update') ||
            HasPermission('user', 'delete')) && (
            <AsideMenuItem to='app/users/businesusers' title='Users' hasBullet={true} />
          )}
          {(HasPermission('app_keys', 'create') ||
            HasPermission('app_keys', 'read') ||
            HasPermission('app_keys', 'update') ||
            HasPermission('app_keys', 'delete')) && (
            <AsideMenuItem to='app/sendkeys' title='Send User Keys' hasBullet={true} />
          )}
        </AsideMenuItemWithSub>
      )}

      <AsideMenuItemWithSub
        to='/settings'
        title='Profile Settings'
        fontIcon='bi-sticky'
        icon='/media/icons/duotune/communication/com006.svg'
      >
        <AsideMenuItem to='settings/viewprofile' title='View Profile' hasBullet={true} />
        <AsideMenuItem to='settings/updateprofile' title='Update Profile' hasBullet={true} />
      </AsideMenuItemWithSub>
    </>
  )
}
